module.exports = __webpack_public_path__ + "img/mobiledirectposter.864d47fd.jpg";